import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';

export default function TabLeft({ children }) {
  return (
    <Row>
      <Col xs={{ span: 21, offset: 1 }}>
        {children}
      </Col>
    </Row>
  );
}

TabLeft.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
